import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as PlayIcon } from 'assets/icons/play.svg';
import { ClearButton } from './styled';

const PauseIcon = styled.div`
  width: 100%;
  height: 100%;
  color: var(--text-color);
  display: inline-flex;
  justify-content: space-between;

  &::before,
  &::after {
    content: '';
    background-color: currentColor;
    display: block;
    width: 33%;
    height: 100%;
    border-radius: 2px;
  }

  &:hover {
    color: var(--blue);
  }
`;

const MediaPlayButton = ({ audioFile, volume }) => {
  if (!audioFile.formats) {
    // load when fully ready
    return null;
  }

  const soundUrl = audioFile.formats.reference.url;
  const [audio] = useState(new Audio(soundUrl));
  const [isPLaying, setIsPlaying] = useState(false);

  useEffect(() => {
    audio.addEventListener('ended', () => setIsPlaying(false));
  }, [audio]);

  // Update volume when it changes
  useEffect(() => {
    if (typeof volume === 'number') {
      audio.volume = Math.max(0, Math.min(1, volume));
    }
  }, [audio, volume]);

  const handlePlay = evt => {
    evt.stopPropagation();

    if (isPLaying) {
      audio.pause();
      audio.currentTime = 0;
      setIsPlaying(false);
    } else {
      audio.play();
      setIsPlaying(true);
    }
  };

  return <ClearButton onClick={handlePlay}>{isPLaying ? <PauseIcon /> : <PlayIcon />}</ClearButton>;
};

MediaPlayButton.propTypes = {
  audioFile: PropTypes.instanceOf(Object).isRequired,
  volume: PropTypes.number,
};

MediaPlayButton.defaultProps = {
  volume: 1,
};

export default MediaPlayButton;
